import AuthGuard from '../components/AuthGuard';
import { useNavigate } from 'react-router-dom';
import { useEffect, useMemo, useRef, useState } from 'react';
import { api } from '../lib/api';
import toast from 'react-hot-toast';

export default function CheckinPage() {
  const navigate = useNavigate();
  const [streak, setStreak] = useState(0);
  const [checked, setChecked] = useState(false);
  const [nextReward, setNextReward] = useState<{ consecutive_days: number; loss: number; stable_coin: number; stock: number } | null>(null);
  const [open, setOpen] = useState(true);
  const [checkedDates, setCheckedDates] = useState<string[]>([]);
  const [today, setToday] = useState<string>('');

  async function load() {
    try {
      const { data } = await api.get('/checkin/status');
      setStreak(data.streak ?? 0);
      setChecked(!!data.checked_today);
      setNextReward(data.next_reward ?? null);
      setCheckedDates(Array.isArray(data.checked_dates) ? data.checked_dates : []);
      setToday(typeof data.today === 'string' ? data.today : '');
    } catch { toast.error('加载失败'); }
  }
  useEffect(() => { load(); api.get('/config/features').then(({ data }) => setOpen(data?.checkin_open !== false)).catch(() => setOpen(true)); }, []);

  async function submit() {
    try {
      const { data } = await api.post('/checkin');
      toast.success('签到成功');
      setStreak(data.streak ?? 0);
      setChecked(true);
      if (today) setCheckedDates(prev => prev.includes(today) ? prev : [...prev, today].sort());
    } catch (err: any) { toast.error(err?.response?.data?.message ?? '签到失败'); }
  }

  function getYearMonth() { const d = today ? new Date(today + 'T00:00:00') : new Date(); return { year: d.getFullYear(), monthIndex: d.getMonth() }; }
  function pad(n: number) { return n < 10 ? `0${n}` : `${n}`; }
  function formatYMD(year: number, monthIndex: number, day: number) { return `${year}-${pad(monthIndex + 1)}-${pad(day)}`; }
  function buildCalendar() {
    const { year, monthIndex } = getYearMonth(); const first = new Date(year, monthIndex, 1);
    const daysInMonth = new Date(year, monthIndex + 1, 0).getDate(); const startWeekday = first.getDay();
    const cells: { label: string; date?: string; checked?: boolean; isToday?: boolean }[] = [];
    for (let i = 0; i < startWeekday; i++) cells.push({ label: '' });
    for (let d = 1; d <= daysInMonth; d++) { const dateStr = formatYMD(year, monthIndex, d); cells.push({ label: `${d}`, date: dateStr, checked: checkedDates.includes(dateStr), isToday: today === dateStr }); }
    return { cells, year, monthIndex };
  }

  return (
    <div className="max-w-md mx-auto min-h-screen relative " style={{ backgroundColor: '#8b0000' }}>
      <AuthGuard /> 

      {/* Header */}
      <div className="relative pt-4 px-4">
        <button
          onClick={() => navigate(-1)}
          className="absolute top-4 left-4 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-white/80 text-black"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <div className="flex flex-col items-center gap-3 justify-center relative mb-5">
          <h4 className="text-white">绑定银行卡</h4>
        </div>
      </div>

        <div className="mx-auto max-w-md px-4">
          <div className="pt-5 rounded-2xl bg-orange-50 p-4 shadow">
            <div className="text-center text-2xl">连续签到 {streak} 天</div>
            <div className="mt-2 text-center text-[12px] text-gray-600">连续签到获得更多奖励</div>
          </div>
          <div className="mt-4 rounded-2xl bg-white p-4 shadow">
            <div className="text-sm">签到规则</div>
            <div className="mt-2 text-[12px] text-gray-600">每天可签到一次，达到特定连续天数获得奖励</div>
            {(() => { const nd = streak + 1; const loss = nextReward?.loss ?? 0; return (<div className="mt-2 text-[12px] text-gray-600">下一次奖励：连续 {nd} 天，团队补偿金 {loss}</div>); })()}
          </div>
          {(() => { const { cells, year, monthIndex } = buildCalendar(); const monthTitle = `${year}年${pad(monthIndex + 1)}月`; return (
            <div className="mt-4 rounded-2xl bg-white p-4 shadow">
              <div className="text-sm">{monthTitle}</div>
              <div className="mt-2 grid grid-cols-7 gap-2 text-center text-[12px] text-gray-600">
                <div>日</div><div>一</div><div>二</div><div>三</div><div>四</div><div>五</div><div>六</div>
              </div>
              <div className="mt-2 grid grid-cols-7 gap-2">
                {cells.map((c, idx) => (<div key={idx} className={`h-10 rounded-lg border text-center text-sm leading-10 ${c.label ? (c.checked ? 'bg-green-100 border-green-300 text-green-700' : 'bg-gray-50 border-gray-200') : 'border-transparent'}`}>{c.label || ''}</div>))}
              </div>
              <div className="mt-2 text-[12px] text-gray-600">绿色为已签到</div>
            </div>
          ); })()}
          <button onClick={submit} disabled={checked || !open} className="mt-6 w-full rounded-xl bg-red-600 py-3 text-white disabled:bg-gray-400">{!open ? '签到已关闭' : checked ? '今日已签到' : '立即签到'}</button>
        </div> 
    </div>
  );
}